exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-row {\r\n    margin-top: 10px;\r\n}\r\n.text-right {\r\n    text-align: right!important;\r\n}\r\n\r\n.pointer-text:hover{\r\n    cursor: pointer;\r\n    color: blue!important;\r\n    text-decoration: underline!important;\r\n    font-weight: bolder;\r\n}\r\n\r\n.link{\r\n    color: blue!important;\r\n    text-decoration: underline!important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/components/administra-productos/administra-productos.component.css
// module id = ../../../../../src/app/components/administra-productos/administra-productos.component.css
// module chunks = 1